import cookie from 'cookie'
import { ApolloClient, InMemoryCache, HttpLink } from 'apollo-boost'
import fetch from 'isomorphic-unfetch'
import {BACKEND_URL} from "../config/config"

let apolloClient = null

function create (initialState,token) {
  // Check out https://github.com/zeit/next.js/pull/4611 if you want to use the AWSAppSyncClient
  console.log(token)
  const isBrowser = typeof window !== 'undefined'
  return new ApolloClient({
    connectToDevTools: isBrowser,
    ssrMode: !isBrowser, // Disables forceFetch on the server (so queries are only run once)

    link: new HttpLink({
      uri: BACKEND_URL+'/graphql', // Server URL (must be absolute)
      headers: {Authorization:token},
      //credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
      // Use fetch() polyfill on the server
      fetch: !isBrowser && fetch
    }),
    fetchOptions: {
      mode: 'no-cors',
    },
    cache: new InMemoryCache().restore(initialState || {})
  })
}

export default function initApollo (initialState,token) {
  // Make sure to create a new client for every server-side request so that data
  // isn't shared between connections (which would be bad)
  if (typeof window === 'undefined') {
    return create(initialState,token)
  }

  // Reuse client on the client-side
  if (!apolloClient) {
    apolloClient = create(initialState,token)
  }

  return apolloClient
}
